// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TopSpace{\n    margin-top: -2rem;\n}\n.input{\n    width: 150px;\n    height: 20px;\n}\n\nForm.Control{\n    width: 150px;\n    height: 20px;\n}", ""]);
// Exports
module.exports = exports;
